import { useToast } from "@chakra-ui/react";

export function handlePaymentStatusError(
  toast: ReturnType<typeof useToast>,
  error: unknown,
) {
  console.error("Failed to update payment status:", error);
  toast({
    title: "Error",
    description: "Failed to update payment status. Please try again.",
    status: "error",
    duration: 5000,
    isClosable: true,
  });
}

export function handlePaymentStatusSuccess(
  toast: ReturnType<typeof useToast>,
  type: "bulk" | "individual",
) {
  toast({
    title: "Success",
    description:
      type === "bulk"
        ? "Studies have been marked as paid successfully."
        : "Study has been marked as paid successfully.",
    status: "success",
    duration: 3000,
    isClosable: true,
  });
}

export function getPayableToReaderFilterOptions(paymentStatusFilter: string | null) {
  if (!paymentStatusFilter) {
    return ["true", "false"];
  } else if (paymentStatusFilter === "NONPAYABLE") {
    return ["false"];
  } else {
    return ["true"];
  }
}

export function getPaymentStatusFilterOptions(payableToReaderFilter: string | null) {
  if (!payableToReaderFilter) {
    return ["PENDING", "PAYABLE", "PAID", "NONPAYABLE"];
  } else if (payableToReaderFilter === "true") {
    return ["PENDING", "PAYABLE", "PAID"];
  } else {
    return ["NONPAYABLE"];
  }
}
